/*
 * 入库管理-CSG
 */

import EmptyRouter from '@/layout/EmptyRouter.vue';
import EmptyRouterAlive from '@/layout/EmptyRouterAlive.vue';

export default {
    path: 'inbound',
    name: 'BusinessInbound',
    component: EmptyRouterAlive,
    meta: {
      title: '入库管理',
    },
    children: [
    // csg入库单admin端
      {
        path: 'purchase',
        name: 'BusinessPurchaseOrderCsgAdminIndex',
        component: EmptyRouter,
        redirect: 'inbound/index',
        meta: {
          title: 'csg入库单',
        },
        children: [
          {
            path: 'inbound/index',
            name: 'BusinessPurchaseOrderCsgAdminIndex',
            component: () => import('@/views/center-business/purchase/inbound/index'),
            meta: {
              title: '未完成入库单',
              isCache: true,
            },
          },
          {
            path: 'inbound/detail',
            name: 'BusinessPurchaseOrderCsgAdminDetail',
            component: () => import('@/views/center-business/purchase/inbound/detail'),
            meta: {
              title: '入库单详情',
            },
            hidden: true,
          },
          {
            path: 'order/csg-admin/receive',
            name: 'BusinessPurchaseOrderCsgAdminReceive',
            component: () => import('@/views/center-business/purchase/order/csg-admin/receive'),
            meta: {
              title: '查询入库单',
            },
            hidden: true,
          },
          {
            path: 'order/csg/add',
            name: 'BusinessPurchaseOrderCsgAdd',
            component: () => import('@/views/center-business/purchase/order/csg/add'),
            meta: {
              title: '新增入库单',
              isCache: true,
            },
            hidden: true,
          },
          {
            path: 'order/csg-admin/edit',
            name: 'BusinessPurchaseOrderCsgAdminEdit',
            component: () => import('@/views/center-business/purchase/order/csg-admin/edit'),
            meta: {
              title: '修改入库单',
              isCache: true,
            },
            hidden: true,
          },
          {
            path: 'order/csg-admin/verify',
            name: 'BusinessPurchaseOrderCsgAdminVerify',
            component: () => import('@/views/center-business/purchase/order/csg-admin/verify'),
            meta: {
              title: '尺寸校验',
              isCache: true,
            },
            hidden: true,
          },
        ],
      },
      {
        path: 'purchase',
        name: 'BusinessPurchaseOrderCsgAdminclosedIndex',
        component: EmptyRouter,
        redirect: 'inbound/closedIndex',
        meta: {
          title: '已完成入库单',
        },
        children: [
          {
            path: 'inbound/closedIndex',
            name: 'BusinessPurchaseOrderCsgAdminclosedIndex',
            component: () => import('@/views/center-business/purchase/inbound/closedIndex'),
            meta: {
              title: '已完成入库单',
              isCache: true,
            },
          },
        ],
      },
      {
        path: 'purchase',
        name: 'BusinessPurchaseOrderTimeConfigure',
        component: EmptyRouter,
        redirect: 'TimeConfigure',
        meta: {
          title: '入库时间配置',
        },
        children: [
          {
            path: 'TimeConfigure',
            name: 'BusinessPurchaseOrderTimeConfigure',
            component: () => import('@/views/center-business/purchase/TimeConfigure'),
            meta: {
              title: '入库时间配置',
              isCache: true,
            },
          },
        ],
      },
      // 未完成临时存储
      {
        path: 'temporaryNot',
        name: 'BusinessPurchaseTemporaryNot',
        component: EmptyRouter,
        redirect: 'temporaryNot/index',
        meta: {
          title: '未完成临时存储',
        },
        children: [
          {
            path: 'temporaryNot/index',
            name: 'BusinessPurchaseTemporaryNot',
            component: () => import('@/views/center-business/purchase/temporary/temporaryNot/index'),
            meta: {
              title: '未完成临时存储',
              isCache: true,
            },
          },
        ],
      },
      // 已完成临时存储
      {
        path: 'temporaryYet',
        name: 'BusinessPurchaseTemporaryYet',
        component: EmptyRouter,
        redirect: 'temporaryYet/index',
        meta: {
          title: '已完成临时存储',
        },
        children: [
          {
            path: 'temporaryYet/index',
            name: 'BusinessPurchaseTemporaryYet',
            component: () => import('@/views/center-business/purchase/temporary/temporaryYet/index'),
            meta: {
              title: '已完成临时存储',
              isCache: true,
            },
          },
        ],
      },
    ],
  };
